import { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.js";

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch {
      setError("Email o contraseña incorrectos.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8f6f0" }}>
      <form onSubmit={handleSubmit} style={{
        background: "#fff", padding: 40, borderRadius: 12, width: 340,
        boxShadow: "0 2px 16px rgba(0,0,0,0.08)", display: "flex", flexDirection: "column", gap: 16
      }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Autoexistencia</h1>
          <p style={{ color: "#666", margin: "4px 0 0", fontSize: 13 }}>Panel privado · IA Influencer</p>
        </div>
        {error && <div style={{ background: "#fef2f2", color: "#dc2626", padding: "8px 12px", borderRadius: 6, fontSize: 13 }}>{error}</div>}
        <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 13, color: "#444" }}>
          Email
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
            style={{ padding: "8px 12px", border: "1px solid #ddd", borderRadius: 6, fontSize: 14, outline: "none" }} />
        </label>
        <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 13, color: "#444" }}>
          Contraseña
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
            style={{ padding: "8px 12px", border: "1px solid #ddd", borderRadius: 6, fontSize: 14, outline: "none" }} />
        </label>
        <button type="submit" disabled={loading} style={{
          padding: "10px 0", background: "#2d6a4f", color: "#fff", border: "none",
          borderRadius: 6, fontSize: 15, fontWeight: 600, cursor: loading ? "wait" : "pointer",
          opacity: loading ? 0.7 : 1
        }}>{loading ? "Entrando…" : "Entrar"}</button>
      </form>
    </div>
  );
}
